import React from 'react';
import { v4 as uuidv4 } from 'uuid';

export default ({ classes }) => [
  {
    children: [
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.subCategory.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.subCategory.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.subCategory.fontSize',
            fontWeight: 'typography.branches.subCategory.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.subCategory.color'
          }
        ],
        labelText: 'Sub Category',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.productHeader.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.productHeader.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.productHeader.background',
            fontSize: 'typography.branches.productHeader.fontSize',
            fontWeight: 'typography.branches.productHeader.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.productHeader.color'
          },
          {
            labelText: 'Background Color',
            name: 'palette.branches.productHeader.background'
          }
        ],
        labelText: 'Product Header',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.bodyCopy.fontFamily', // TODO: Update this theme path
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.bodyCopy.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.bodyCopy.fontSize',
            fontWeight: 'typography.branches.bodyCopy.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.bodyCopy.color'
          }
        ],
        labelText: 'Body Copy',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.heroDescription.fontFamily', // TODO: Update this theme path
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls' // TODO: Update this theme path
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.heroDescription.fontWeight', // TODO: Update this theme path
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.product.background',
            fontSize: 'typography.branches.heroDescription.fontSize',
            fontWeight: 'typography.branches.heroDescription.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.heroDescription.color' // TODO: Update this theme path
          }
        ],
        labelText: 'Hero Description',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.heroValue.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.heroValue.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.product.background',
            fontSize: 'typography.branches.heroValue.fontSize',
            fontWeight: 'typography.branches.heroValue.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.heroValue.color'
          }
        ],
        labelText: 'Hero Value',
        name: uuidv4()
      }
    ],
    labelText: 'Typography',
    name: uuidv4()
  },
  {
    children: [
      {
        exclude: true,
        name: 'brancheslogo',
        placeholder: 'Paste the logo image address',
        tooltip: (
          <div className={classes.tooltip}>
            To temporarily display your logo, copy the logo’s image address from a browser and
            paste it in the designated logo field. Bottomline requires the source logo file be
            sent via email, for final implementation.
          </div>
        ),
        type: 'string',
        labelText: 'Institution Logo'
      },
      {
        name: 'palette.branches.header.background',
        labelText: 'Background Color'
      },
      {
        backgroundColor: 'palette.branches.header.background',
        fontSize: 'typography.branches.heroValue.fontSize',
        fontWeight: 'typography.branches.heroValue.fontWeight',
        name: 'typography.branches.header.color',
        labelText: 'Text Color'
      },
      {
        labelText: 'Font',
        name: 'typography.branches.header.fontFamily',
        placeholder: 'Paste the web font URL',
        tooltip: (
          <div className={classes.tooltip}>
            Copy the web font URL and paste it in the designated typography fields.
          </div>
        ),
        type: 'fontFamily',
        urlName: 'typography.branches.fontFamilies.urls'
      }
    ],
    labelText: 'Header',
    name: uuidv4()
  },
  {
    children: [
      {
        children: [
          {
            labelText: 'Corner Radius',
            name: 'oaoButtons.branches.selectButton.borderRadius',
            type: 'pixel'
          },
          {
            labelText: 'Idle Background Color',
            name: 'oaoButtons.branches.selectButton.background'
          },
          {
            labelText: 'Idle Border Color',
            name: 'oaoButtons.branches.selectButton.borderColor'
          },
          {
            labelText: 'Hover Background Color',
            name: 'oaoButtons.branches.selectButton.hoverBackground'
          },
          {
            labelText: 'Hover Border Color',
            name: 'oaoButtons.branches.selectButton.hoverBorderColor'
          },
          {
            labelText: 'Font',
            name: 'oaoButtons.branches.selectButton.fontFamily',
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Font Weight',
            name: 'oaoButtons.branches.selectButton.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'oaoButtons.branches.selectButton.background',
            fontSize: 'oaoButtons.branches.selectButton.fontSize',
            fontWeight: 'oaoButtons.branches.selectButton.fontWeight',
            labelText: 'Idle Text Color',
            name: 'oaoButtons.branches.selectButton.color'
          },
          {
            backgroundColor: 'oaoButtons.branches.selectButton.hoverBackground',
            fontSize: 'oaoButtons.branches.selectButton.fontSize',
            fontWeight: 'oaoButtons.branches.selectButton.fontWeight',
            labelText: 'Hover Text Color',
            name: 'oaoButtons.branches.selectButton.hoverColor'
          }
        ],
        labelText: 'Select Button',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Corner Radius',
            name: 'oaoButtons.branches.applyButton.borderRadius',
            type: 'pixel'
          },
          {
            labelText: 'Idle Background Color',
            name: 'oaoButtons.branches.applyButton.background'
          },
          {
            labelText: 'Idle Border Color',
            name: 'oaoButtons.branches.applyButton.borderColor'
          },
          {
            labelText: 'Hover Background Color',
            name: 'oaoButtons.branches.applyButton.hoverBackground'
          },
          {
            labelText: 'Hover Border Color',
            name: 'oaoButtons.branches.applyButton.hoverBorderColor'
          },
          {
            labelText: 'Font',
            name: 'oaoButtons.branches.applyButton.fontFamily',
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Font Weight',
            name: 'oaoButtons.branches.applyButton.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'oaoButtons.branches.applyButton.background',
            fontSize: 'oaoButtons.branches.applyButton.fontSize',
            fontWeight: 'oaoButtons.branches.applyButton.fontWeight',
            labelText: 'Idle Text Color',
            name: 'oaoButtons.branches.applyButton.color'
          },
          {
            backgroundColor: 'oaoButtons.branches.applyButton.hoverBackground',
            fontSize: 'oaoButtons.branches.applyButton.fontSize',
            fontWeight: 'oaoButtons.branches.applyButton.fontWeight',
            labelText: 'Hover Text Color',
            name: 'oaoButtons.branches.applyButton.hoverColor'
          }
        ],
        labelText: 'Apply Button',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Corner Radius',
            name: 'oaoButtons.branches.setButton.borderRadius',
            type: 'pixel'
          },
          {
            labelText: 'Idle Background Color',
            name: 'oaoButtons.branches.setButton.background'
          },
          {
            labelText: 'Idle Border Color',
            name: 'oaoButtons.branches.setButton.borderColor'
          },
          {
            labelText: 'Hover Background Color',
            name: 'oaoButtons.branches.setButton.hoverBackground'
          },
          {
            labelText: 'Hover Border Color',
            name: 'oaoButtons.branches.setButton.hoverBorderColor'
          },
          {
            labelText: 'Font',
            name: 'oaoButtons.branches.setButton.fontFamily',
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Font Weight',
            name: 'oaoButtons.branches.setButton.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'oaoButtons.branches.setButton.background',
            fontSize: 'oaoButtons.branches.setButton.fontSize',
            fontWeight: 'oaoButtons.branches.setButton.fontWeight',
            labelText: 'Idle Text Color',
            name: 'oaoButtons.branches.setButton.color'
          },
          {
            backgroundColor: 'oaoButtons.branches.setButton.hoverBackground',
            fontSize: 'oaoButtons.branches.setButton.fontSize',
            fontWeight: 'oaoButtons.branches.setButton.fontWeight',
            labelText: 'Hover Text Color',
            name: 'oaoButtons.branches.setButton.hoverColor'
          }
        ],
        labelText: 'Set Button',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'oaoButtons.branches.tab.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'oaoButtons.branches.tab.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.h2.fontSize',
            fontWeight: 'typography.h2.fontWeight',
            labelText: 'Color',
            name: 'oaoButtons.branches.tab.color'
          },
          {
            backgroundColor: 'oaoButtons.branches.tab.background',
            fontSize: 'oaoButtons.branches.tab.fontSize',
            fontWeight: 'oaoButtons.branches.tab.fontWeight',
            labelText: 'Active Color',
            name: 'oaoButtons.branches.tab.activeColor'
          },
          {
            labelText: 'Active Border Color',
            name: 'oaoButtons.branches.tab.activeBorderColor'
          }
        ],
        labelText: 'Tab',
        name: uuidv4()
      }
    ],
    labelText: 'Buttons',
    name: uuidv4()
  },
  {
    children: [
      {
        labelText: 'Font',
        name: 'oaoButtons.branches.subnavigation.fontFamily',
        placeholder: 'Paste the web font URL',
        tooltip: (
          <div className={classes.tooltip}>
            Copy the web font URL and paste it in the designated typography fields.
          </div>
        ),
        type: 'fontFamily',
        urlName: 'typography.branches.fontFamilies.urls'
      },
      {
        labelText: 'Weight',
        name: 'oaoButtons.branches.subnavigation.fontWeight',
        type: 'fontWeight'
      },
      {
        backgroundColor: 'palette.background',
        fontWeight: 'oaoButtons.branches.subnavigation.fontWeight',
        labelText: 'Color',
        name: 'oaoButtons.branches.subnavigation.background'
      },
      {
        backgroundColor: 'oaoButtons.branches.subnavigation.background',
        fontWeight: 'oaoButtons.branches.subnavigation.fontWeight',
        labelText: 'Type Color',
        name: 'oaoButtons.branches.subnavigation.color'
      },
      {
        backgroundColor: 'palette.background',
        fontWeight: 'oaoButtons.branches.subnavigation.fontWeight',
        labelText: 'Active Color',
        name: 'oaoButtons.branches.subnavigation.activeBackground'
      },
      {
        backgroundColor: 'oaoButtons.branches.subnavigation.activeBackground',
        fontWeight: 'oaoButtons.branches.subnavigation.fontWeight',
        labelText: 'Active Type Color',
        name: 'oaoButtons.branches.subnavigation.activeColor'
      }
    ],
    labelText: 'Mobile Subcategory',
    name: uuidv4()
  },
  {
    children: [
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.errorHeader.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.errorHeader.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.errorHeader.fontSize',
            fontWeight: 'typography.branches.errorHeader.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.errorHeader.color'
          }
        ],
        labelText: 'Header',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.errorSubHeader.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.errorSubHeader.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.errorSubHeader.fontSize',
            fontWeight: 'typography.branches.errorSubHeader.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.errorSubHeader.color'
          }
        ],
        labelText: 'Sub Header',
        name: uuidv4()
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.branches.errorBodyCopy.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.branches.fontFamilies.urls'
          },
          {
            labelText: 'Weight',
            name: 'typography.branches.errorBodyCopy.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.errorBodyCopy.fontSize',
            fontWeight: 'typography.branches.errorBodyCopy.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.errorBodyCopy.color'
          }
        ],
        labelText: 'Body Copy',
        name: uuidv4()
      },
      {
        children: [
          {
            backgroundColor: 'palette.branches.background',
            fontSize: 'typography.branches.errorBodyCopy.fontSize',
            fontWeight: 'typography.branches.errorBodyCopy.fontWeight',
            labelText: 'Color',
            name: 'typography.branches.errorLink.color'
          }
        ],
        labelText: 'Link',
        name: uuidv4()
      }
    ],
    labelText: 'Error Page',
    name: uuidv4()
  }
];
